import angular from 'angular';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';

angular
  .module('cxSettings')
  .controller('AddTaskTemplateDialogCtrl', [
    '$element',
    '$scope',
    '$http',
    'appUrls',
    'flySvc',
    'resourceFactorySvc',
    'dataCache',
    'translateListFilter',
    'resourceNameFilter',
    'enumCacheSvc',
    'close',
    'resources',
    'costResources',
    addTaskTemplateDialogCtrl,
  ]);

function addTaskTemplateDialogCtrl(
  $element,
  $scope,
  $http,
  appUrls,
  flySvc,
  resourceFactorySvc,
  dataCache,
  translateListFilter,
  resourceNameFilter,
  enumCacheSvc,
  close,
  resources,
  costResources,
) {
  var vm = this;
  vm.showValidation = false;
  vm.translation = {};
  vm.template = {
    name: '',
    appliesToPerson: true,
    appliesToSoleProprietor: true,
    appliesToCompany: true,
    isCommonUse: true,
    resourceId: dataCache.getDefaultCompany().defaultTaskResourceId,
    assignedType: 0,
    userId: null,
    profile: null,
  };
  vm.assignedTo = {
    assignedType: 0,
    userId: null,
    profile: null,
  };
  vm.resources = resources;
  vm.costResources = costResources;
  if (!vm.resources) {
    resourceFactorySvc.get('resource').reg(
      {
        type: 0,
      },
      function(data) {
        vm.resources = data.map(x => ({
          ...x,
          code: x.code | '',
          label: resourceNameFilter(x),
        }));
      },
    );
  }
  if (!vm.costResources) {
    resourceFactorySvc.get('resource').reg(
      {
        type: 1,
      },
      function(data) {
        vm.costResources = data
          .map(item => ({
            ...item,
            label: resourceNameFilter(item),
            code: item.code || '',
          }))
          .sort(dynamicSortMultiple('code', 'label'));
      },
    );
  }

  vm.users = dataCache
    .getArray('user')
    .filter(x => x.isActive || !x.hidden)
    .map(function(user) {
      return {
        id: user.userID,
        label: `${user.firstName} ${user.lastName}`,
        isActive: user.isActive,
      };
    })
    .sortByProperty('name');

  vm.profiles = [];
  enumCacheSvc.get('employeeprofile').then(function(data) {
    vm.profiles = data.map(({ key, value }) => ({
      id: key,
      value,
      label: translateListFilter(key, 'employeeprofile', value),
    }));
  });

  vm.assignedToChanged = function() {
    angular.extend(vm.template, vm.assignedTo);
  };

  vm.updateName = function(value) {
    vm.template.name = value;
  };

  vm.save = function() {
    if ($scope.form.$invalid) return;
    if (vm.translation && !vm.translation.isValid(true)) return;
    vm.saving = true;
    $http.post(appUrls.tasks + '/api/tasktemplates/templates', vm.template).then(
      function({ data = {} }) {
        vm.saving = false;
        if (data && data.id && vm.translation && vm.translation.save) {
          return vm.translation.save(data.id).then(function() {
            $element.modal('hide');
            close(data, 500);
            flySvc.success();
            return false;
          });
        } else {
          $element.modal('hide');
          close(data, 500);
          flySvc.success();
          return false;
        }
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error);
      },
    );
  };

  vm.showValidationErrors = function() {
    vm.showValidation = true;
    if (vm.translation && vm.translation.isValid) vm.translation.isValid(true);
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
